<template>
  <div class="transfer">
    <div class="transfer-menu transfer-left">
      <div
        class="transfer-item"
        v-for="(item, index) in leftData"
        :key="index"
        @click="selectLeftData(item, index)">
        <div class="transfer-select"></div>{{item.label}}
      </div>
    </div>
    <div class="transfer-menu transfer-btn text-[red] bg-[blue]">
      <button>到左边</button>
      <button>到右边</button>
    </div>
    <div class="transfer-menu transfer-right"></div>
  </div>
</template>
<script>
export default {
  props: ['data'],
  data() {
    return {
      leftData: []
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler() {
        this.leftData = this.data;
      }
    }
  },
  methods: {
    selectLeftData(data, index) {}
  },
}
</script>
<style lang="scss" scoped>
.transfer {
  display: flex;
  align-items: center;
  * {
    box-sizing: border-box;
  }
  .transfer-menu {
    width: 200px;
    height: 500px;
    // background: red;
    border: 1px solid #ccc;
    padding: 10px;
  }
  .transfer-btn {
    border: none;
  }
  .transfer-item {
    height: 35px;
    display: flex;
    align-items: center;
    cursor: pointer;
    .transfer-select {
      width: 14px;
      height: 14px;
      border: 1px solid #ccc;
      margin-right: 4px;
    }
  }
}
</style>